export default __webpack_public_path__ + "static/media/sbo-dropdown.0a1506f3.webp";